
import React from 'react';
import { Card } from '@/components/ui/card';
import { Profile } from '@/types/profile';
import {
  normalizeSmokerDisplay,
  normalizeDrinkerDisplay,
  normalizePiercingsDisplay,
  normalizeTattoosDisplay
} from '@/utils/profileDisplayUtils';

interface ProfileLifestyleSectionProps {
  profile: Profile;
}

export const ProfileLifestyleSection: React.FC<ProfileLifestyleSectionProps> = ({ profile }) => {
  return (
    <Card className="bg-white/5 border-white/10 p-4">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-8 h-8 bg-blue-500/20 rounded-full flex items-center justify-center">
          <span className="text-lg">🏃</span>
        </div>
        <h3 className="text-white font-medium text-sm">Estilo de Vida</h3>
      </div>
      <div className="grid grid-cols-2 gap-4 text-xs">
        {profile.smoker && (
          <div>
            <p className="text-white/60">Fumante</p>
            <p className="text-white">{normalizeSmokerDisplay(profile.smoker)}</p>
          </div>
        )}
        {profile.drinker && (
          <div>
            <p className="text-white/60">Bebidas</p>
            <p className="text-white">{normalizeDrinkerDisplay(profile.drinker)}</p>
          </div>
        )}
        {profile.piercings && (
          <div>
            <p className="text-white/60">Piercings</p>
            <p className="text-white">{normalizePiercingsDisplay(profile.piercings)}</p>
          </div>
        )}
        {profile.tattoos && (
          <div>
            <p className="text-white/60">Tatuagens</p>
            <p className="text-white">{normalizeTattoosDisplay(profile.tattoos)}</p>
          </div>
        )}
      </div>
    </Card>
  );
};
